import React from "react";
import Home from "./Home";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

function App() {

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/" element={<Navigate replace to="/home" />}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;